import WOW from 'wowjs';

import '../landing.css'

import { useEffect, useState } from 'react';
import Header from '../components/Header';
import phoneCodes from '../../../core/data/phoneCodes';
import Footer from '../components/Footer';
import { useContacto } from './hooks/useContacto';
import { ToastContainer } from 'react-toastify';

function ContactoPage() {

    const [visible, setVisible] = useState(true);

    const {
        state,
        form,
        functions
    } = useContacto();

    useEffect(() => {
        new WOW.WOW().init();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const handleClick = ({
        phone = "16892589039",
        message = "Hola, quiero más información",
    }) => {
        const ua = navigator.userAgent || navigator.vendor || window.opera;

        const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;

        // URL de WhatsApp
        const whatsappURL = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}&app_absent=0`;

        // En iOS Safari, abrir directamente
        if (isIOS) {
            window.location.href = whatsappURL;
        } else {
            window.open(whatsappURL, "_blank", "noopener,noreferrer");
        }
    };

    return (
        <>
            <ToastContainer />
            <Header currentSection='contacto' />
            <section id='contacto' className="container contacto pt-100 w-100 d-flex flex-column justify-content-center align-items-center">
                <div className='row align-items-center z-1'>
                    <div className='col-md-6'>
                        <div className='p-4 z-1 wow slideInLeft'>
                            <h1 className="fw-bold text-primary fw-bold">¿Necesitas ayuda con tu proceso migratorio?</h1>
                            <h1 className="parrafo text-secondary mt-4">
                                Llena este formulario y uno de nuestros asesores se pondrá en contacto contigo en menos de 24 horas.
                            </h1>
                            <br />
                            <br />
                            <div className='text-center text-md-start'>
                                <button onClick={handleClick} className="border-0 text-white text-decoration-none px-3 py-3 rounded-4 mt-5 text-center wow bounce z-1 " style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)', background: "#c12a21" }}>
                                    <i className="bi bi-whatsapp"></i> ¿Tienes alguna duda? Escribenos
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6 p-5'>
                        <form onSubmit={form.handleSubmit(functions.guadrarFormulario)}>
                            <div className="col">
                                <label className="form-label fw-bold text-secondary">Nombre <span className='text-danger'>*</span></label>
                                <div className="input-group mb-3">
                                    <button className="bg-secondary rounded-start-3 px-2" type="button">
                                        <i className="bi bi-person text-white"></i>
                                    </button>
                                    <input
                                        {...form.register("nombre", { required: "Debes digitar el nombre" })}
                                        placeholder="Nombre..."
                                        type="text"
                                        className={`form-control ${form.errors.nombre ? 'is-invalid' : ''}`}
                                    />
                                    <div className="invalid-feedback">
                                        {form.errors.nombre?.message}
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <label className="form-label fw-bold text-secondary">Correo <span className='text-danger'>*</span></label>
                                <div className="input-group mb-3">
                                    <button className="bg-secondary rounded-start-3 px-2" type="button">
                                        <i className="bi bi-envelope text-white"></i>
                                    </button>
                                    <input
                                        {...form.register("correo", { required: "Debes digitar el correo" })}
                                        placeholder="Correo..."
                                        type="email"
                                        className={`form-control ${form.errors.correo ? 'is-invalid' : ''}`}
                                    />
                                    <div className="invalid-feedback">
                                        {form.errors.correo?.message}
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-5 col-md-6">
                                    <label className="form-label fw-bold text-secondary">Telefono <span className='text-danger'>*</span></label>
                                    <div className="input-group mb-3">
                                        <button className="bg-secondary rounded-start-3 px-2" type="button">
                                            <i className="bi bi-phone text-white"></i>
                                        </button>
                                        <select
                                            {...form.register("prefijoTelefono", { required: "Debes seleccionar un prefijo" })}
                                            className={`form-select ${form.errors.prefijoTelefono ? 'is-invalid' : ''}`}
                                        >
                                            {phoneCodes.map((country, index) => (
                                                country.code == "" ?
                                                    <option key={index} value={country.code}>
                                                        {country.name}
                                                    </option> :
                                                    <option key={index} value={country.code}>
                                                        {country.name} ({country.code})
                                                    </option>
                                            ))}
                                        </select>
                                        <div className="invalid-feedback">
                                            {form.errors.prefijoTelefono?.message}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-7 col-md-6">
                                    <label className="form-label fw-bold text-secondary">.</label>
                                    <div className="input-group mb-3">
                                        <input
                                            {...form.register("numeroTelefono", { required: "Debes digitar el numero de telefono" })}
                                            placeholder="Telefono"
                                            type="number"
                                            className={`form-control ${form.errors.numeroTelefono ? 'is-invalid' : ''}`}
                                        />
                                        <div className="invalid-feedback">
                                            {form.errors.numeroTelefono?.message}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <label className="form-label fw-bold text-secondary">¿En cuál servicio estás interesado? <span className='text-danger'>*</span></label>
                                <div className="input-group mb-3">
                                    <button className="bg-secondary rounded-start-3 px-2" type="button">
                                        <i className="bi bi-universal-access text-white"></i>
                                    </button>
                                    <select
                                        {...form.register("servicio")}
                                        className='form-select'
                                    >
                                        <option value="asilo">Asilo</option>
                                        <option value="peticion familiar">Petición familiar</option>
                                        <option value="otro">Otro</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col">
                                <label className="form-label fw-bold text-secondary">Mensaje breve <small className='text-grey'>(opcional)</small></label>
                                <textarea {...form.register("mensaje")} className='form-control' rows="4"></textarea>
                            </div>
                            <div className="text-center mt-4">
                                {
                                    state.loading ? (
                                        <button className="btn btn-primary" type="button" disabled>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            &nbsp; Enviando información...
                                        </button>
                                    ) : (
                                        <button className="btn text-white text-center" type="submit" style={{ fontSize: 'clamp(0.9rem, 2vw, 1.2rem)', background: "#c12a21" }}>
                                            <i className="bi bi-send text-white"></i>&nbsp;Enviar y solicitar asesoría gratuita
                                        </button>
                                    )
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <Footer />
            <div className="chat-container">
                {visible && (
                    <div className="chat-popup">
                        <div className="chat-text">
                            <strong>Asilo a tu Alcance</strong><br />
                            ¡Hola! Soy tu asesor de Inmigración. ¿Cómo te puedo ayudar?
                        </div>
                        <span className="close-btn" onClick={() => setVisible(false)}>×</span>
                    </div>
                )}
                <div className="chat-icon">
                    <button onClick={handleClick} className="border-0 btn-wsp d-flex align-items-center justify-content-center" target="_blank">
                        <i className="bi bi-whatsapp icono"></i>
                    </button>
                </div>
            </div>
        </>
    );
}

export default ContactoPage;